class ContentShare extends HTMLElement {
  connectedCallback() {
    if (this.initialized) return;
    this.initialized = true;
    const trigger = this.querySelector('[data-share-trigger]');
    const dialog = this.querySelector('dialog');
    const copyButton = this.querySelector('[data-copy-share]');
    const status = this.querySelector('[role="status"]');
    trigger.hidden = false;
    copyButton.hidden = false;
    const linkField = this.querySelector('.content-share__link');
    linkField.addEventListener('click', () => linkField.select());
    const messagesLink = this.querySelector('[data-share-messages]');
    // iOS uses an ampersand before the body; desktop and other SMS clients use a query.
    const appleDevice = /iPhone|iPad|iPod/.test(navigator.userAgent) ||
      (navigator.platform === 'MacIntel' && navigator.maxTouchPoints > 1);
    messagesLink.href = `sms:${appleDevice ? '&' : '?'}body=${encodeURIComponent(this.dataset.url)}`;
    messagesLink.addEventListener('click', () => {
      status.textContent = 'Choose your messaging app if prompted. If the link is missing, copy the page link below and paste it into your draft.';
    });

    // Sharing must not activate the containing artwork card.
    this.addEventListener('click', (event) => event.stopPropagation());
    trigger.addEventListener('click', () => {
      status.textContent = '';
      dialog.showModal();
    });
    this.querySelector('[data-share-close]').addEventListener('click', () => dialog.close());
    dialog.addEventListener('close', () => {
      if (!dialog.open) trigger.focus();
    });
    dialog.addEventListener('click', (event) => {
      const bounds = dialog.getBoundingClientRect();
      if (event.target === dialog && (
        event.clientX < bounds.left || event.clientX > bounds.right ||
        event.clientY < bounds.top || event.clientY > bounds.bottom
      )) dialog.close();
    });
    copyButton.addEventListener('click', async () => {
      try {
        await navigator.clipboard.writeText(this.dataset.url);
        status.textContent = 'Link copied';
      } catch {
        linkField.focus();
        linkField.select();
        // Some embedded browsers deny the Clipboard API but allow copying a selection.
        let copied = false;
        try {
          copied = document.execCommand('copy');
        } catch { /* Keep the selected link available for manual copying. */ }
        status.textContent = copied ? 'Link copied' : 'Link selected. Touch and hold to copy, or press Command+C on Mac / Ctrl+C on Windows.';
      }
    });
  }
}
if (!customElements.get('content-share')) customElements.define('content-share', ContentShare);
